import { Lazy } from '@betgames/bg-state-manager';
import { storageRepository } from '@betgames/bg-tools';
import { httpClient } from 'repositories/HttpClientRepository';
import AppFeaturesStore from './AppFeatures.store';
import AppFeaturesRepository from './AppFeatures.repository';

const appFeaturesRepository = new AppFeaturesRepository(httpClient);

export const appFeatures = new Lazy(
    () => new AppFeaturesStore(storageRepository, appFeaturesRepository),
);
export { appFeaturesSelectors } from './AppFeatures.selectors';
